export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_02.b338919a.mp4";